import React, { useEffect, useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Mousewheel } from 'swiper/modules';
import '../components-css/portfolio.scss'; // Your styles
import axios from 'axios';
import { BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import ArrowIcon from '../assets/svgs/black-arrow.svg';
import GradientArrowIcon from '../assets/svgs/Group 3 (5).svg';
import leftArrow from '../assets/svgs/leftArrow.svg';
import rightArrow from '../assets/svgs/rightArrow.svg';
import AOS from 'aos';
import 'aos/dist/aos.css';

const MySlider = () => {
    const [portfolioData, setPortfolioData] = useState([]);
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    const wheelTimeout = useRef(null);

    useEffect(() => {
        const getPortfolioData = async () => {
            const response = await axios.get(`${BASE_URL}/portfolio?for=home`);
            setPortfolioData(response.data.data);
        };
        getPortfolioData();
    }, []);

    const isTouchDevice = () => {
        return (('ontouchstart' in window) || navigator.maxTouchPoints > 0);
    };

    useEffect(() => {
        AOS.init({ duration: 1000, once: true, offset: 50 }); // Initialize AOS with animation duration
    }, []);

    useEffect(() => {
        if (portfolioData.length > 0) {
            const swiper = swiperRef.current;
            if (swiper && !swiper.destroyed) {
                // Full recalculation sequence — must happen in this order
                // swiper.updateSize();
                // swiper.updateSlides();
                // swiper.updateProgress();
                // swiper.updateSlidesClasses();
                // swiper.autoplay.start();
            }
        }
    }, [portfolioData]);

    const [isHovered, setIsHovered] = useState(false);

    return (
        // No data-aos here — AOS hides this container with opacity:0 which
        // makes Swiper think it has 0 width and autoplay never works properly.
        // The fade animation is handled purely in CSS below via @keyframes.
        <div className="portfolio-slider-container portfolio-slider-aos">
            <Swiper
                // data-aos="fade-top"
                ref={swiperRef}
                slidesPerView={3.3}
                loop={true}
                spaceBetween={30}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                mousewheel={
                    window.innerWidth > 768
                        ? {
                            forceToAxis: true,
                            sensitivity: 0.7,
                            thresholdDelta: 40,
                        }
                        : false
                }
                navigation={false}
                modules={[Mousewheel, Autoplay]}
                className="testimonial-swiper"
                onSwiper={(swiper) => (swiperRef.current = { swiper })}
            >
                {portfolioData.map((image, index) => (
                    <SwiperSlide key={index} className="portfolio-slide">
                        <div className="portfolio-image-container" onClick={() => {
                            sessionStorage.setItem("homeScrollPosition", window.scrollY);
                            navigate(`/portfolio/${image.id}`);
                        }}
                            onMouseEnter={() => {
                                // Desktop only hover effect
                                if (!('ontouchstart' in window) && navigator.maxTouchPoints === 0) {
                                    setIsHovered(true);
                                }
                            }}
                            onMouseLeave={() => {
                                if (!('ontouchstart' in window) && navigator.maxTouchPoints === 0) {
                                    setIsHovered(false);
                                }
                            }}>
                            <img className="image" src={image.banner_path + image.banner_image} alt={`Slide ${index + 1}`} />
                            {/* <button
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                onClick={() => navigate(`/portfolio/${image.id}`)}
                                className="hover-button"
                            >
                                View Project
                                <span className='img'>
                                    {isHovered ? (
                                        <img src={GradientArrowIcon} alt="gradient-icon" />
                                    ) : (
                                        <img src={ArrowIcon} alt="arrow-icon" />
                                    )}
                                </span>
                            </button> */}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Custom Navigation Buttons */}
            {/* <div className="swiper-button-prev">
                <img src={leftArrow} alt="left-arrow" />
            </div>
            <div className="swiper-button-next">
                <img src={rightArrow} alt="right-arrow" />
            </div> */}
        </div>
    );
};

export default MySlider;